import * as i0 from '@angular/core';
import { Component, Directive, InjectionToken, Injectable, Optional, Inject, NgModule } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/router';
import { NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { assert } from '@sdpp-web/util';

class SharePortalRoutingService {
    constructor() {
        this._activeRoute = `${window.location.pathname}${window.location.search}`;
        this._activeRoute$ = new BehaviorSubject(this._activeRoute);
        this._activeRouteLabel$ = new BehaviorSubject('');
    }
    get activeRoute() {
        return this._activeRoute;
    }
    get activeRoute$() {
        return this._activeRoute$.asObservable();
    }
    get activeRouteLabel$() {
        return this._activeRouteLabel$.asObservable();
    }
    startLabelMonitoring() {
        document.addEventListener(SharePortalRoutingService.SHARE_PORTAL_ROUTING_LABEL_EVENT, (e) => {
            if (e.detail.source === 'host') {
                this._activeRouteLabel = e.detail.label;
                this._activeRouteLabel$.next(this._activeRouteLabel);
            }
        });
    }
    start() {
        // in: host <- app
        document.addEventListener(SharePortalRoutingService.SHARE_PORTAL_ROUTING_EVENT, (e) => {
            if (e.detail.source === 'app') {
                this._activeRoute = e.detail.url;
                this._activeRoute$.next(this._activeRoute);
            }
        });
    }
    dispatch(url, label) {
        if (url) {
            const [pathname, search] = url.split('?');
            // out: host -> app
            document.dispatchEvent(new CustomEvent(SharePortalRoutingService.SHARE_PORTAL_ROUTING_EVENT, {
                detail: {
                    source: 'host',
                    routerLink: pathname,
                    queryParams: (search || '')
                        .split('&')
                        .filter(term => term)
                        .reduce((queryParams, term) => {
                        const [key, value] = term.split('=');
                        return Object.assign(Object.assign({}, queryParams), { [key]: value });
                    }, {})
                }
            }));
        }
        if (label) {
            this.setRouteLabel(label);
        }
    }
    setRouteLabel(label) {
        document.dispatchEvent(new CustomEvent(SharePortalRoutingService.SHARE_PORTAL_ROUTING_LABEL_EVENT, {
            detail: {
                source: 'host',
                label
            }
        }));
    }
}
SharePortalRoutingService.SHARE_PORTAL_ROUTING_EVENT = 's-share-portal-routing-event';
SharePortalRoutingService.SHARE_PORTAL_ROUTING_LABEL_EVENT = 's-share-portal-routing-label-event';

function SharePortalActiveRouteComponent_span_0_Template(rf, ctx) {
    if (rf & 1) {
        i0.ɵɵelementStart(0, "span");
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
    }
    if (rf & 2) {
        const activeRouteLabel_r1 = ctx.ngIf;
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", activeRouteLabel_r1, "");
    }
}
class SharePortalActiveRouteComponent {
    constructor(_sharePortalRoutingService) {
        this._sharePortalRoutingService = _sharePortalRoutingService;
        this._sharePortalRoutingService.startLabelMonitoring();
    }
    ngOnInit() {
        this.activeRouteLabel$ = this._sharePortalRoutingService.activeRouteLabel$;
    }
}
/** @nocollapse */ /** @nocollapse */ SharePortalActiveRouteComponent.ɵfac = function SharePortalActiveRouteComponent_Factory(t) { return new (t || SharePortalActiveRouteComponent)(i0.ɵɵdirectiveInject(SharePortalRoutingService)); };
/** @nocollapse */ /** @nocollapse */ SharePortalActiveRouteComponent.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: SharePortalActiveRouteComponent, selectors: [["s-share-portal-active-route"]], features: [i0.ɵɵProvidersFeature([SharePortalRoutingService])], decls: 2, vars: 3, consts: [[4, "ngIf"]], template: function SharePortalActiveRouteComponent_Template(rf, ctx) {
        if (rf & 1) {
            i0.ɵɵtemplate(0, SharePortalActiveRouteComponent_span_0_Template, 2, 1, "span", 0);
            i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.activeRouteLabel$));
        }
    }, directives: [i2.NgIf], pipes: [i2.AsyncPipe], encapsulation: 2 });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SharePortalActiveRouteComponent, [{
            type: Component,
            args: [{ selector: 's-share-portal-active-route', providers: [SharePortalRoutingService], template: "<span *ngIf=\"activeRouteLabel$ | async as activeRouteLabel\"> {{ activeRouteLabel }}</span>\r\n" }]
        }], function () { return [{ type: SharePortalRoutingService }]; }, null);
})();

class SharePortalRoutingDirective {
    constructor(router) {
        // in: app <- host
        document.addEventListener(SharePortalRoutingService.SHARE_PORTAL_ROUTING_EVENT, (e) => {
            if (e.detail.source === 'host') {
                router.navigate([e.detail.routerLink], { queryParams: e.detail.queryParams });
            }
        });
        // out: app -> host
        router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((e) => {
            document.dispatchEvent(new CustomEvent(SharePortalRoutingService.SHARE_PORTAL_ROUTING_EVENT, {
                detail: {
                    source: 'app',
                    url: e.url
                }
            }));
        });
    }
}
/** @nocollapse */ /** @nocollapse */ SharePortalRoutingDirective.ɵfac = function SharePortalRoutingDirective_Factory(t) { return new (t || SharePortalRoutingDirective)(i0.ɵɵdirectiveInject(i1.Router)); };
/** @nocollapse */ /** @nocollapse */ SharePortalRoutingDirective.ɵdir = /** @pureOrBreakMyCode */ i0.ɵɵdefineDirective({ type: SharePortalRoutingDirective, selectors: [["", "sSharePortalRouting", ""]] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SharePortalRoutingDirective, [{
            type: Directive,
            args: [{
                    selector: '[sSharePortalRouting]'
                }]
        }], function () { return [{ type: i1.Router }]; }, null);
})();

var Environment;
(function (Environment) {
    Environment["Dev"] = "DEV";
    Environment["Uat"] = "UAT";
    Environment["PreProd"] = "PREPROD";
    Environment["Prod"] = "PROD";
})(Environment || (Environment = {}));
/**
 * Compares two environments.
 * Returns a negative value if a < b, 0 if a = b, and positive value otherwise.
 */
var EnvironmentHelper;
(function (EnvironmentHelper) {
    const environmentPrecedence = {
        [Environment.Dev]: 1,
        [Environment.Uat]: 2,
        [Environment.PreProd]: 3,
        [Environment.Prod]: 4
    };
    function compare(a, b) {
        const aPrecedence = environmentPrecedence[a];
        const bPrecedence = environmentPrecedence[b];
        assert(aPrecedence !== undefined, `"${a}" is not a valid environment`);
        assert(bPrecedence !== undefined, `"${b}" is not a valid environment`);
        return bPrecedence - aPrecedence;
    }
    EnvironmentHelper.compare = compare;
})(EnvironmentHelper || (EnvironmentHelper = {}));

var MetaName;
(function (MetaName) {
    MetaName["Portal"] = "portal";
    MetaName["PortalUrl"] = "portal-url";
    MetaName["Whitelabel"] = "whitelabel";
    MetaName["Theme"] = "theme";
    MetaName["DeployUrl"] = "deploy-url";
    MetaName["Network"] = "intranet";
    MetaName["Version"] = "version";
    MetaName["CdnAppName"] = "cdn-app-name";
    MetaName["Environment"] = "environment";
    MetaName["AppName"] = "app-name";
})(MetaName || (MetaName = {}));

var Network;
(function (Network) {
    Network["Intranet"] = "true";
    Network["Internet"] = "false";
})(Network || (Network = {}));

var Portal;
(function (Portal) {
    Portal["SmartDerivatives"] = "smartderivatives";
    Portal["Brio"] = "brio";
    Portal["Enqdc"] = "enqdc";
    Portal["SdppAdmin"] = "sdppadmin";
    Portal["Cda"] = "cda";
})(Portal || (Portal = {}));

/**
 * TODO Sdpp Web should enable one Theme to belong to multiple white Labels.
 * This way we could have: simba-light and simba-dark themes belong to WL BnpParibas, SmartUs and SeFlow.
 * As this is not possible today, we need to create SmartUsLight, SmartUsDark, SeFlowLight and SeFlowDark themes
 * which point to the simba themes css.
 */
var Theme;
(function (Theme) {
    // simba
    Theme["SimbaLight"] = "simba-light";
    Theme["SimbaDark"] = "simba-dark";
    // bancagenerali
    Theme["BancageneraliLight"] = "bancagenerali-light";
    // ingdirect
    Theme["IngDirectLight"] = "ingdirect-light";
    // jsafrasarasin
    Theme["JSafraSarasinLight"] = "jsafrasarasin-light";
    // unionbancaireprivee
    Theme["UnionBancairePriveeLight"] = "unionbancaireprivee-light";
    // cais
    Theme["CaisLight"] = "cais-light";
    // insigneo
    Theme["InsigneoLight"] = "insigneo-light";
    // smart us
    Theme["SmartUsLight"] = "smartus-light";
    Theme["SmartUsDark"] = "smartus-dark";
    // se flow
    Theme["SeFlowLight"] = "seflow-light";
    Theme["SeFlowDark"] = "seflow-dark";
    // xap-evergreen
    Theme["XapEvergreen"] = "xap-evergreen";
})(Theme || (Theme = {}));

var Whitelabel;
(function (Whitelabel) {
    Whitelabel["BnpParibas"] = "bnpparibas";
    Whitelabel["Bancagenerali"] = "bancagenerali";
    Whitelabel["IngDirect"] = "ing";
    Whitelabel["JSafraSarasin"] = "jsafrasarasin";
    Whitelabel["UnionBancairePrivee"] = "ubp";
    Whitelabel["Cais"] = "cais";
    Whitelabel["Insigneo"] = "insigneo";
    Whitelabel["SmartUs"] = "smartus";
    Whitelabel["SeFlow"] = "seflow";
})(Whitelabel || (Whitelabel = {}));

var WebComponent;
(function (WebComponent) {
    WebComponent["Code"] = "code";
    WebComponent["CdnAppName"] = "cdn-app-name";
    WebComponent["Version"] = "version";
    WebComponent["DeployUrl"] = "deploy-url";
})(WebComponent || (WebComponent = {}));

class ThemeConfig {
    /**
     * Gets the Theme variables
     * @param theme the Theme
     */
    static getThemeConfig(theme) {
        let blotter = null;
        let blotterCondensed = null;
        let blotterXCondensed = null;
        switch (theme) {
            case Theme.XapEvergreen:
                blotter = blotterCondensed = blotterXCondensed = { headerHeight: 20, rowHeight: 20 };
                break;
            default:
                blotter = { headerHeight: 52, rowHeight: 42 };
                blotterCondensed = { headerHeight: 44, rowHeight: 32 };
                blotterXCondensed = { headerHeight: 30, rowHeight: 25 };
        }
        return { blotter, blotterCondensed, blotterXCondensed };
    }
}

/**
 * Token used to configure the different sdpp-web modules
 */
const SDPP_API_BASE = new InjectionToken('sdpp-api-base');
const BASE_SDPP_API = '/api/sdpp';

class MetaInfoService {
    constructor() {
        this._metaValues = new Map();
    }
    /**
     * Gets a meta
     * @param metaName the name of the meta
     */
    getMeta(metaName) {
        return this._getMeta(metaName);
    }
    getMetaForWebComponent(appCode, field) {
        return this._getMeta(`${appCode}:${field}`);
    }
    _getMeta(metaName) {
        if (!this._metaValues.has(metaName)) {
            const links = document.querySelectorAll(`meta[name="${metaName}"]`);
            if (links.length > 0) {
                this._metaValues.set(metaName, links[0].content);
            }
        }
        return this._metaValues.get(metaName);
    }
}
/** @nocollapse */ /** @nocollapse */ MetaInfoService.ɵfac = function MetaInfoService_Factory(t) { return new (t || MetaInfoService)(); };
/** @nocollapse */ /** @nocollapse */ MetaInfoService.ɵprov = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjectable({ token: MetaInfoService, factory: MetaInfoService.ɵfac, providedIn: 'root' });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MetaInfoService, [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], function () { return []; }, null);
})();

class UrlService {
    constructor(sdppApiBase) {
        this.baseSdppApi = sdppApiBase || BASE_SDPP_API;
    }
    getUrl(path) {
        return `${this.baseSdppApi}${path}`;
    }
    getBackgroundUrl(path) {
        return `/background${this.baseSdppApi}${path}`;
    }
}
/** @nocollapse */ /** @nocollapse */ UrlService.ɵfac = function UrlService_Factory(t) { return new (t || UrlService)(i0.ɵɵinject(SDPP_API_BASE, 8)); };
/** @nocollapse */ /** @nocollapse */ UrlService.ɵprov = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjectable({ token: UrlService, factory: UrlService.ɵfac, providedIn: 'root' });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UrlService, [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], function () {
        return [{ type: undefined, decorators: [{
                        type: Optional
                    }, {
                        type: Inject,
                        args: [SDPP_API_BASE]
                    }] }];
    }, null);
})();

class SdppWebPortalModule {
}
/** @nocollapse */ /** @nocollapse */ SdppWebPortalModule.ɵfac = function SdppWebPortalModule_Factory(t) { return new (t || SdppWebPortalModule)(); };
/** @nocollapse */ /** @nocollapse */ SdppWebPortalModule.ɵmod = /** @pureOrBreakMyCode */ i0.ɵɵdefineNgModule({ type: SdppWebPortalModule });
/** @nocollapse */ /** @nocollapse */ SdppWebPortalModule.ɵinj = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjector({ providers: [MetaInfoService], imports: [[CommonModule]] });
(function () {
    (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdppWebPortalModule, [{
            type: NgModule,
            args: [{
                    declarations: [SharePortalRoutingDirective, SharePortalActiveRouteComponent],
                    imports: [CommonModule],
                    exports: [SharePortalRoutingDirective, SharePortalActiveRouteComponent],
                    providers: [MetaInfoService]
                }]
        }], null, null);
})();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SdppWebPortalModule, { declarations: [SharePortalRoutingDirective, SharePortalActiveRouteComponent], imports: [CommonModule], exports: [SharePortalRoutingDirective, SharePortalActiveRouteComponent] }); })();

/*
 * Public API Surface of sdpp-web-portal
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BASE_SDPP_API, Environment, EnvironmentHelper, MetaInfoService, MetaName, Network, Portal, SDPP_API_BASE, SdppWebPortalModule, SharePortalActiveRouteComponent, SharePortalRoutingDirective, SharePortalRoutingService, Theme, ThemeConfig, UrlService, WebComponent, Whitelabel };
